import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  margin: auto;
`;

export const Column = styled.div`
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  width: 50%;
  &:first-child {
  }
`;

export const GameContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const DevText = styled.p`
  text-align: center;
  font-size: 0.8rem;
`;
